import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "w-full md:w-8/12" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row justify-between mt-4"
}
const _hoisted_4 = { class: "w-1/2 pr-3" }
const _hoisted_5 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_6 = { class: "flex flex-row justify-between mt-4" }
const _hoisted_7 = { class: "flex flex-row justify-between mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: _ctx.titlePage,
    "full-page": "",
    "custom-class": "px-0",
    "vertical-separator": false,
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[6] || (_cache[6] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage,
    loading: _ctx.apiGetData.loading,
    error: !!this.apiGetData.errorType,
    errorType: this.apiGetData.errorType,
    onTryAgain: _ctx.fetchDetail
  }, {
    "top-right": _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_lp_button, {
          "text-color": "white",
          customClass: "w-full py-2.5",
          title: "Simpan",
          onClick: _ctx.onSaveForm,
          disabled: !_ctx.isFormValid
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    data: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        (!_ctx.isFormTypeAdd)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_DataWrapper, {
                  label: "ID",
                  asterisk: "",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LpInput, {
                      modelValue: _ctx.form.id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.id = $event)),
                      disabled: "",
                      disableBackground: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataWrapper, {
            label: "Nama Pengguna",
            asterisk: "",
            class: "w-full mr-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.form.username,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.username = $event)),
                placeholder: "Masukkan nama pengguna",
                maxLength: "50"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_DataWrapper, {
            label: "Kode Klien Parent",
            asterisk: "",
            class: "w-full mr-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.form.clientId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.clientId = $event)),
                placeholder: "Masukkan kode klien parent genesis",
                maxLength: "50"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Nomor Telepon Klien",
            optional: "",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.form.clientPhone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.clientPhone = $event)),
                format: _ctx.formatNumber,
                placeholder: "Masukkan nomor telepon klien",
                maxLength: "20"
              }, null, 8, ["modelValue", "format"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_DataWrapper, {
            label: "Token",
            optional: "",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.form.webhookToken,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.webhookToken = $event)),
                placeholder: "Masukkan token",
                maxLength: "1000"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "leave-page-confirmation", "onLeavePage", "loading", "error", "errorType", "onTryAgain"]))
}